// src/components/russia-map/ExcelImportButton.tsx

import { Button } from "@/components/ui/button";
import { useRef } from "react";

interface ExcelImportButtonProps {
  canShow: boolean; // true, если показывать кнопку (isPavlik && canEditRegion)
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ExcelImportButton = ({ canShow, onFileChange }: ExcelImportButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  if (!canShow) return null; // если не нужно показывать — ничего не рендерим

  return (
    <>
      <Button
        size="sm"
        onClick={() => fileInputRef.current?.click()}
        className="bg-gradient-to-r from-indigo-600 to-cyan-600 hover:from-indigo-700 hover:to-cyan-700 text-xs"
      >
        Excel
      </Button>

      <input
        type="file"
        accept=".xlsx,.xls"
        ref={fileInputRef}
        onChange={onFileChange}
        className="hidden"
      />
    </>
  );
};